import React, { Component } from 'react';
import { Card, Icon, Tooltip } from 'material-ui';
import { withStyles } from 'material-ui/styles/index';
import classNames from 'classnames';
import GoogleMap from 'google-map-react';
import ReactTable from "react-table";
import axios from 'axios';

const styles = theme => ({
    root: {}
});

function Marker({ text }) {

    return (
        <Tooltip title={text} placement="top">
            <Icon className="text-red">place</Icon>
        </Tooltip>
    );
}

class Widget17 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            outstData: [],
            
        }

        this.loadInvoiceOutstandingPaymentByToday();
    }

    loadInvoiceOutstandingPaymentByToday() {

        axios.get(window.salesServer+'/receipt/getInvoiceOutstandingPaymentByToday')
            .then(response => {

                if (response == undefined || response == null || response == "" || 0 == response.data.length) {
                    console.log("//////////error///////////////////////sdf/////");
                } else {
                    console.log("////////////////getInvoiceOutstandingPaymentByToday////////////");
                    console.log(response.data.result);
                    this.loadDataAll(response.data.result);
                }

            }).catch(function (error) {

                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    loadDataAll(response) {

        var data = [];

        for (let i = 0; i < response.length; i++) {

            var paymentTerm = null;
            if (null == response[i].PAYMENT_TERM_NET || undefined == response[i].PAYMENT_TERM_NET || "" == response[i].PAYMENT_TERM_NET) {
                paymentTerm = response[i].PAYMENT_TERM_BY;
            } else {
                paymentTerm = (response[i].PAYMENT_TERM_NET).split("T")[0];
            }

            data.push({
                idInvoiceHeader: response[i].ID_INVOICE_HEADER,
                idCustomer: response[i].CUSTOMER_ID,
                referenceNo: response[i].REFERENCE_NO,
                customer: response[i].CUSTOMER_NAME,
                netAmount: response[i].NET_AMOUNT,
                term : paymentTerm,
                lastBillDate : response[i].BILL_DATE.split("T")[0],
                outstanding : response[i].OUTSTANDING
            });
        }
        this.setState({outstData : data});

    }

    render() {
        const { data, classes } = this.props;
        return (
            <Card className={classNames(classes.root, "w-full")}>
                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    data={this.state.outstData}
                    columns={[

                        {
                            Header: "ID_INVOICE_HEADER",
                            accessor: "idInvoiceHeader",
                            show: false
                        },
                        {
                            Header: "CUSTOMER_ID",
                            accessor: "idCustomer",
                            show: false
                        },

                        {
                            Header: "Reference No",
                            accessor: "referenceNo",
                            // show: false,
                            filterable: true
                        },
                        {
                            Header: "Customer",
                            accessor: "customer",
                            filterable: true

                        },
                        {
                            Header: "Net Amount",
                            accessor: "netAmount",
                            filterable: true

                        },

                        {
                            Header: "Term",
                            accessor: "term",
                            filterable: true

                        },

                        {
                            Header: "Last Bill",
                            accessor: "lastBillDate",
                            filterable: true

                        },

                        {
                            Header: "Outstanding",
                            accessor: "outstanding",
                            filterable: true

                        },

                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight"
                />

            </Card>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Widget17);



// WEBPACK FOOTER //
// ./src/main/content/apps/dashboards/widgets/Widget17.js